import { TextField } from '@mui/material';

const TranslationInput = ({
  label,
  value = {},
  onChange,
  onBlur,
  required = false,
  multiline = false,
  rows = 1,
  error = false,
  helperText = '',
  disabled = false,
}) => {
  const handleChange = (newValue) => {
    onChange({
      ...value,
      en: newValue,
    });
  };

  const handleBlur = () => {
    if (onBlur) {
      onBlur({
        ...value,
        en: value.en || '',
      });
    }
  };

  return (
    <TextField
      label={label}
      value={value.en || ''}
      onChange={(e) => handleChange(e.target.value)}
      onBlur={handleBlur}
      fullWidth
      required={required}
      multiline={multiline}
      rows={rows}
      error={error}
      helperText={helperText}
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
      sx={{
        mb: 0,
        '& .MuiInputBase-root': {
          fontSize: '14px',
        },
        '& .MuiInputLabel-root': {
          fontSize: '14px',
        },
        '& .MuiFormHelperText-root': {
          fontSize: '12px',
          color: '#9E9EAD',
        },
      }}
    />
  );
};

export default TranslationInput;





